import React, { Component } from 'react';
import ContactInfo from './ContactInfo';
import { connect } from 'react-redux';
import { sendContact } from '../actions/ProfilAction';

class Contact extends Component {
  sendEmail(e) {
    e.preventDefault();
    this.props.sendContact(
      document.getElementById('name').value,
      document.getElementById('email').value,
      document.getElementById('object').value,
      document.getElementById('body').value
    );
  }

  handleChange(event, name) {
    this.setState({
      name: event.target.value,
    });
  }

  render() {
    return (
      <section className={this.props.background} id="contact">
        <div className="container mt-5">
          <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            {this.props.minimal || (
              <div className="row">
                <div className="col-12 mb-3">
                  <span className={`txt-bold txt-25px txt-white txt-uppercase`}>Contactez nous</span>
                </div>
                <div className="col-12">
                  <form className="row" onSubmit={e => this.sendEmail(e)}>
                    <div className="col-6">
                      <input className={`input-special input-white m-5px p-2 pl-4`} id={'name'} placeholder="Nom" />
                    </div>
                    <div className="col-6">
                      <input className={`input-special input-white m-5px p-2 pl-4`} id={'email'} placeholder="Email" />
                    </div>
                    <div className="col-12">
                      <input className={`input-special input-white p-2 pl-4`} placeholder="Objet" id={'object'} />
                    </div>
                    <div className="col-12">
                      <textarea
                        placeholder="Votre message"
                        id={'body'}
                        className={`input-special input-white m-5px p-2 pl-4`}
                      />
                    </div>
                    <div className="col-12 mt-2">
                      <button className={`btn-custom btn-white`}>Envoyer</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            <ContactInfo info={this.props.info} textColor={`txt-white`} iconColor={this.props.color} />
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.login.token,
  };
};
export default connect(mapStateToProps, { sendContact })(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact.js